import { render, staticRenderFns } from "./e-chinese.vue?vue&type=template&id=027e26b5&scoped=true"
import script from "./e-chinese.vue?vue&type=script&lang=js"
export * from "./e-chinese.vue?vue&type=script&lang=js"
import style0 from "./e-chinese.vue?vue&type=style&index=0&id=027e26b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e26b5",
  null
  
)

export default component.exports